module.exports = __webpack_public_path__ + "static/media/download.50113554.svg";